export default {
  title: 'Configuration',

  languages: {
    title: 'Languages'
  }
}
